import type React from "react";
import { useState, useRef, useEffect } from "react";

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  placeholder?: string;
  style?: React.CSSProperties;
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className = "",
  style = {},
  placeholder = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSI4MDAiIHZpZXdCb3g9IjAgMCAxMjAwIDgwMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjEyMDAiIGhlaWdodD0iODAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik01ODAgNDAwSDYyMFY0NDBINTgwVjQwMFoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+",
}) => {
  const [imageSrc, setImageSrc] = useState(placeholder);
  // const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setImageSrc(src);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [src]);

  // const handleLoad = () => {
  //   setIsLoaded(true);
  // };

  return (
    <img
      ref={imgRef}
      src={imageSrc || "/placeholder.svg"}
      alt={alt}
      className={`transition-opacity duration-300 ${className}`}
      // onLoad={handleLoad}
      loading="lazy"
      style={style}
    />
  );
};

export default LazyImage;
